/**
 * BismillahCSS Framework Presets
 * Pre-defined theme configurations for different futuristic aesthetics.
 */
export const bPresets = {
    deep_cyber: {
        colors: {
            primary: "#00f2ff",
            secondary: "#7000ff",
            background: "#050507",
            surface: "#0a0a0c",
        },
        glows: {
            primary: "0 0 20px rgba(0, 242, 255, 0.4)",
        }
    },
    solar_aurora: {
        colors: {
            primary: "#ffbb00",
            secondary: "#00ff88",
            background: "#080808",
            surface: "#101010",
        },
        glows: {
            primary: "0 0 30px rgba(255, 187, 0, 0.3)",
        }
    },
    void_silk: {
        colors: {
            primary: "#ffffff",
            secondary: "#333333",
            background: "#000000",
            surface: "#050505",
        },
        glows: {
            primary: "0 0 15px rgba(255, 255, 255, 0.2)",
        }
    },
    glass_frost: {
        colors: { primary: "rgba(255,255,255,0.2)", background: "transparent" },
        blur: "16px"
    },
    neumorphic_soft: {
        colors: { primary: "#e0e0e0", secondary: "#bebebe", background: "#e0e0e0" },
        shadows: "20px 20px 60px #bebebe, -20px -20px 60px #ffffff"
    },
    cyber_neon: {
        colors: { primary: "#00f2ff", background: "#050507" },
        glows: { primary: "0 0 20px #00f2ff" }
    }
};

export const applyPreset = (name: keyof typeof bPresets) => bPresets[name];
